import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { SHOW_CARD_WITH_ANIMATION } from '../../../store/constants';
import { StoreContext } from '../../../store/store';
import CardOne from './card-1/card-one';
import CardTwo from './card-2/card-two';
import CardThree from './card-3/card-three';
import CardFour from './card-4/card-four';
import CardFive from './card-5/card-five';
import CardSix from './card-6/card-six';
import CardSeven from './card-7/card-seven';
import CardEight from './card-8/card-eight';
import CardNine from './card-9/card-nine';
import CardTen from './card-10/card-ten';
import CardEleven from './card-11/card-eleven';
import CardTwelve from './card-12/card-twelve';
import CardThirteen from './card-13/card-thirteen';
import CardFourteen from './card-14/card-fourteen';
import CardFifteen from './card-15/card-fifteen';
import CardSixteen from './card-16/card-sixteen';
import CardSeventeen from './card-17/card-seventeen';
import CardEighteen from './card-18/card-eighteen';
import CardNineteen from './card-19/card-nineteen';
import CardTwenty from './card-20/card-twenty';
import './cards.scss';

const URL_CARD_PARAMETER = 'card';

const Cards: React.FC = () => {
  const { state, dispatch } = React.useContext(StoreContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const activeCard = state.activeCard;
  const urlCardID = searchParams.get(URL_CARD_PARAMETER);

  useEffect(() => {
    if (urlCardID) {
      dispatch({ type: SHOW_CARD_WITH_ANIMATION, payload: { id: urlCardID } });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!activeCard.id) {
      return;
    }

    if (urlCardID !== activeCard.id && activeCard.isFlipped) {
      searchParams.set(URL_CARD_PARAMETER, activeCard.id);
      setSearchParams(searchParams);

      return;
    }

    if (urlCardID === activeCard.id && !activeCard.isFlipped && activeCard.triggerAnimation === false) {
      searchParams.delete(URL_CARD_PARAMETER);
      setSearchParams(searchParams);
    }
  }, [activeCard, urlCardID, searchParams, setSearchParams]);

  return (
    <div className="bd-cards">
      <CardOne />
      <CardTwo />
      <CardThree />
      <CardFour />
      <CardFive />
      <CardSix />
      <CardSeven />
      <CardEight />
      <CardNine />
      <CardTen />
      <CardEleven />
      <CardTwelve />
      <CardThirteen />
      <CardFourteen />
      <CardFifteen />
      <CardSixteen />
      <CardSeventeen />
      <CardEighteen />
      <CardNineteen />
      <CardTwenty />
    </div>
  );
};

export default Cards;
